import { z } from 'zod'
import { PROFILE_CHECKLIST_STEPS } from './vendor-profile.dto.js'

/**
 * A vendor's page on csvenueview.com, as the company's own people see it on the
 * Profile page (docs/vendor-growth.spec.md, "The public page").
 */

/**
 * Why a page that is on isn't showing: its profile checklist has come undone, or
 * the company signed itself up and hasn't confirmed its email. Either way it
 * comes back by itself.
 */
const VENDOR_PAGE_HIDDEN = ['incomplete', 'unconfirmed'] as const

export type VendorPageHidden = (typeof VENDOR_PAGE_HIDDEN)[number]

export const vendorPublicPageSettingsDtoSchema = z.object({
  on: z.boolean(),
  /**
   * Where the page is on the site, once it has an address: from the first time
   * it is turned on. A path, since the site shares the app's domain.
   */
  path: z.string().nullable(),
  /** Why it isn't showing although it is on; null while it shows, and while it is off. */
  hidden: z.enum(VENDOR_PAGE_HIDDEN).nullable(),
  /** Whether the person reading may turn it on or off: the company's owners only. */
  canPublish: z.boolean(),
  /** The checklist steps still to do; empty once it may be turned on. */
  missing: z.array(z.enum(PROFILE_CHECKLIST_STEPS)),
})

export type VendorPublicPageSettingsDto = z.infer<typeof vendorPublicPageSettingsDtoSchema>
